<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Evaporator Health
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="range"></date-range-selector>
                            <equipment-selector v-model="equip"></equipment-selector>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <scatter-plot variable-x="Evap Approach"
                          variable-y="Evap Approach"
                          :facility_name="facility_name"
                          :equipment_name="equip"
                          :on-only="true"
                          :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                    <scatter-plot variable-x="CHW_Temp_Diff"
                                  variable-y="CHW_Temp_Diff"
                                  :facility_name="facility_name"
                                  :equipment_name="equip"
                                  :on-only="true"
                                  :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                    <scatter-plot variable-x="Flow_Rate"
                                  variable-y="Flow_Rate"
                                  :facility_name="facility_name"
                                  :equipment_name="equip"
                                  :on-only="true"
                                  :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                    <scatter-plot variable-x="CHWS_Temp"
                                  variable-y="CHWR_Temp"
                                  :facility_name="facility_name"
                                  :equipment_name="equip"
                                  :on-only="true"
                                  :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                    <scatter-plot variable-x="Refrigerant_Temp"
                                  variable-y="Refrigerant_Temp"
                                  :facility_name="facility_name"
                                  :equipment_name="equip"
                                  :on-only="true"
                                  :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                     <scatter-plot variable-x="Refrigerant_Press"
                                  variable-y="Refrigerant_Press"
                                  :facility_name="facility_name"
                                  :equipment_name="equip"
                                  :on-only="true"
                                  :date-range="range"
                                  type="dygraph"
                    ></scatter-plot>

                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import DateRangeSelector from '../../components/DateRangeSelector'
  import EquipmentSelector from '../../components/EquipmentSelector'
  import ScatterPlot from '../../components/ScatterPlot'
  export default {
    name: 'EvaporatorHealth',
    components: { ScatterPlot, EquipmentSelector, DateRangeSelector },
    computed: {
      facility_name () {
        return this.$store.state.pointsListStore.facility_name
      }
    },
    data () {
      return {
        range: null,
        equip: null
      }
    }
  }
</script>

<style scoped>

</style>
